import axios from 'axios';
import i18next from 'i18next';
import { createAsyncThunk } from '@reduxjs/toolkit';
import { enqueueRequestErrorSnackbar } from '@pec/aion-ui-core/actions/enqueueSnackbar';

const name = 'documents';

type DownloadParams = {
  documentReferenceId: string;
  afterSuccess: (data: unknown) => void;
};

export const downloadDocument = createAsyncThunk(
  `${name}/download`,
  async ({ documentReferenceId, afterSuccess }: DownloadParams, { dispatch }) => {
    try {
      const response = await axios.get<BlobPart>(`/api/v3/documents/${documentReferenceId}/download`, {
        responseType: 'arraybuffer'
      });
      afterSuccess(response);
    } catch (error) {
      dispatch(
        enqueueRequestErrorSnackbar(i18next.t('subscriber:documents.unableToDownload', 'Unable to download file'))
      );
      throw error;
    }
  }
);
